import { useId } from "react";
import type { IconProps } from "./types";

type Props = IconProps & {
  color1?: string;
  color2?: string;
  showLinerGradient?: boolean;
};

const Coins = ({
  width,
  height,
  color1 = "#FFF500",
  color2 = "#FFBB0C",
  showLinerGradient = true,
  ...props
}: Props) => {
  const gradientId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 27 27"
      fill="none"
      {...props}
    >
      <path
        d="M0 21.1094V23.3333C0 25.1719 4.47917 26.6667 10 26.6667C15.5208 26.6667 20 25.1719 20 23.3333V21.1094C17.849 22.625 13.9167 23.3333 10 23.3333C6.08333 23.3333 2.15104 22.625 0 21.1094ZM16.6667 6.66667C22.1875 6.66667 26.6667 5.17187 26.6667 3.33333C26.6667 1.49479 22.1875 0 16.6667 0C11.1458 0 6.66667 1.49479 6.66667 3.33333C6.66667 5.17187 11.1458 6.66667 16.6667 6.66667ZM0 15.6458V18.3333C0 20.1719 4.47917 21.6667 10 21.6667C15.5208 21.6667 20 20.1719 20 18.3333V15.6458C17.849 17.4167 13.9115 18.3333 10 18.3333C6.08854 18.3333 2.15104 17.4167 0 15.6458ZM21.6667 16.2187C24.651 15.6406 26.6667 14.5677 26.6667 13.3333V11.1094C25.4583 11.9635 23.6823 12.5469 21.6667 12.9062V16.2187ZM10 8.33333C4.47917 8.33333 0 10.1979 0 12.5C0 14.8021 4.47917 16.6667 10 16.6667C15.5208 16.6667 20 14.8021 20 12.5C20 10.1979 15.5208 8.33333 10 8.33333ZM21.4219 11.2656C24.5469 10.7031 26.6667 9.59896 26.6667 8.33333V6.10938C24.8177 7.41667 21.6406 8.11979 18.2969 8.28646C19.8333 9.03125 20.9635 10.0312 21.4219 11.2656Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <radialGradient
          id={gradientId}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(14.7858 23.8866 -30.4188 49.6881 6.24965 5.50793)"
          gradientUnits="userSpaceOnUse"
        >
          {showLinerGradient && <stop stopColor="white" />}
          <stop offset="0.42" stopColor={color1} />
          <stop offset="0.97" stopColor={color2} />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default Coins;
